/**
 *
 * @param color - eg. bg-blue-550
 * @returns
 */
export function Icon({
  svg,
  color = "filter-black",
  className,
}: {
  svg: string;
  /** Tailwind Bg color, for example bg-blue-550 */
  color?: string;
  className?: string;
}) {
  return (
    <div className={className ?? "h-6 w-6"}>
      <img src={svg} alt="" className={"h-full w-full " + color} />
    </div>
  );
}
